"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemSetting = require("@/api/systemSetting");
var _settings = require("@/settings");
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
var _toolsValidate = require("@/utils/toolsValidate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var defaultFormData = {
  detail: '',
  id: 0,
  isDefault: false,
  isShow: false,
  receiverName: '',
  receiverPhone: ''
};
var _default = exports.default = {
  name: 'CouponList',
  data: function data() {
    return {
      dialogVisible: false,
      btnLoading: false,
      roterPre: _settings.roterPre,
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: this.$constants.page.limit[0],
        status: '',
        name: '',
        type: '',
        useType: ''
      },
      formData: Object.assign({}, defaultFormData),
      rules: {
        detail: [{
          required: true,
          message: '请输入商家地址',
          trigger: 'blur'
        }],
        receiverName: [{
          required: true,
          message: '请输入商家姓名',
          trigger: 'blur'
        }],
        receiverPhone: [{
          required: true,
          validator: _toolsValidate.validatePhone,
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:address:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    //添加
    handleAddAddress: function handleAddAddress() {
      this.formData = Object.assign({}, defaultFormData);
      this.dialogVisible = true;
    },
    //编辑
    handleEditAddress: function handleEditAddress(row) {
      this.formData = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (!_this.formData.isShow) _this.formData.isDefault = false;
          _this.formData.id === 0 ? (0, _systemSetting.merchantAddressSaveApi)(_this.formData).then(function (res) {
            _this.$message.success('添加成功');
            _this.dialogVisible = false;
            _this.getList();
          }).catch(function () {
            _this.btnLoading = false;
          }) : (0, _systemSetting.merchantAddressUpdateApi)(_this.formData).then(function (res) {
            _this.$message.success('编辑成功');
            _this.dialogVisible = false;
            _this.getList();
          }).catch(function () {
            _this.btnLoading = false;
          });
        } else {
          return false;
        }
      });
    }),
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _systemSetting.merchantAddressListApi)().then(function (res) {
        _this2.tableData.data = res;
        localStorage.setItem('merchantAddressList', JSON.stringify(res));
        _this2.listLoading = false;
      }).catch(function (res) {
        _this2.listLoading = false;
      });
    },
    // 修改状态
    onchangeIsShow: function onchangeIsShow(row) {
      var _this3 = this;
      if (row.isDefault) return;
      (0, _systemSetting.merchantAddressUpdateShowApi)(row.id).then(function () {
        _this3.$message.success('修改成功');
        _this3.getList();
      }).catch(function () {
        row.status = !row.status;
      });
    },
    // 设置默认地址
    handleSetIsDefault: function handleSetIsDefault(rowData) {
      var _this4 = this;
      this.$modalSure('设置为默认地址吗?').then(function () {
        (0, _systemSetting.merchantAddressSetDefaultApi)(rowData.id).then(function () {
          _this4.$message.success('设置成功');
          _this4.getList();
        });
      });
    },
    handleDelAddress: function handleDelAddress(rowData) {
      var _this5 = this;
      this.$modalSure('删除当前数据?').then(function () {
        (0, _systemSetting.merchantAddressDeleteApi)(rowData.id).then(function () {
          _this5.$message.success('删除成功');
          _this5.getList();
        });
      });
    }
  }
};